import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaBolt } from 'react-icons/fa';
import StorageService from '../utils/storageService';
import IconRenderer from './IconRenderer';

const Footer = () => {
  const [siteTitle, setSiteTitle] = useState('VidDownloader Pro');
  const [socialIcons, setSocialIcons] = useState([]);

  // Load site title and social icons from localStorage
  useEffect(() => {
    const loadData = () => {
      // Load title
      const storedTitle = localStorage.getItem('navbar_title');
      if (storedTitle) {
        setSiteTitle(storedTitle);
      } else {
        setSiteTitle('VidDownloader Pro');
      }

      // Load social icons
      const icons = StorageService.getFooterIcons();
      if (icons.length > 0) {
        setSocialIcons(icons);
      } else {
        // Use default icons if none are saved
        setSocialIcons(StorageService.getDefaultIcons());
      }
    };

    // Load on mount
    loadData();

    // Listen for storage changes (cross-tab)
    window.addEventListener('storage', loadData);

    // Poll for changes (same-tab updates)
    const interval = setInterval(loadData, 500);

    return () => {
      window.removeEventListener('storage', loadData);
      clearInterval(interval);
    };
  }, []);

  const getIconColor = (type) => {
    const colors = {
      youtube: 'text-red-500',
      instagram: 'text-pink-500',
      facebook: 'text-blue-500',
      twitter: 'text-blue-400',
      tiktok: 'text-gray-300',
      linkedin: 'text-blue-600',
      whatsapp: 'text-green-500',
      custom: 'text-purple-500',
    };
    return colors[type?.toLowerCase()] || 'text-gray-400';
  };

  return (
    <footer 
      className="border-t py-12 mt-16"
      style={{ 
        backgroundColor: 'var(--primary)', 
        borderColor: 'var(--accent)',
        color: 'var(--text)'
      }}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col items-center gap-6">
          <motion.div 
            className="flex items-center gap-2"
            whileHover={{ scale: 1.05 }}
          >
            <div 
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ background: `linear-gradient(135deg, var(--secondary), var(--accent))` }}
            >
              <FaBolt style={{ color: 'var(--text)' }} size={20} />
            </div>
            <span className="font-bold text-2xl" style={{ color: 'var(--text)' }}>{siteTitle}</span>
          </motion.div>

          <div className="flex items-center gap-6 flex-wrap justify-center">
            {socialIcons.map((icon) => (
              <motion.a
                key={icon.id}
                href={icon.link}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.2 }}
                className="transition-colors hover:opacity-80"
                style={{ color: 'var(--accent)' }}
                title={icon.iconName}
              >
                <IconRenderer type={icon.type} size={24} />
              </motion.a>
            ))}
          </div>

          <p className="text-sm text-center" style={{ color: 'var(--text)', opacity: 0.7 }}>
            © 2025 {siteTitle}. All rights reserved. | Powered by a secure API service.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
